import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { TramosContent } from './components/TramosContent';

export default function Tramos() {

    return (
        <>
            <MainContent
                component={<TramosContent />}
                titulo={'Tramos'}
                noBackground
                tableMaxWidth
            />
        </>
    );
};
